import { cx } from 'class-variance-authority';
import commonStyles from '@/app/(website)/commonStyles.module.scss';
import styles from './faq.module.scss';
import {
  AccordionRoot,
  AccordionItem,
  AccordionTrigger,
  AccordionContent
} from '@baseline/ui';
import type { FAQAccordionListProps, FaqEntry } from './types';

const FAQAccordionList = ({
  entries,
  defaultOpenFirst = false,
  className
}: Readonly<FAQAccordionListProps>) => {
  if (entries.length === 0) return null;

  return (
    <div className={cx(styles.items, className)}>
      <AccordionRoot
        type="multiple"
        defaultValue={defaultOpenFirst ? ['item-0'] : undefined}
      >
        {entries.map((item: FaqEntry, idx: number) => {
          const value = `item-${idx}`;
          const key = item?.id ?? value;
          return (
            <AccordionItem key={key} value={value} className={styles.item}>
              <AccordionTrigger
                className={cx(commonStyles.sectionSubheadingH6, styles.trigger)}
                icon="chevronFAQ"
              >
                {item?.question}
              </AccordionTrigger>
              <AccordionContent
                className={cx(commonStyles.sectionParagraph, styles.content)}
              >
                <p>{item?.answer}</p>
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </AccordionRoot>
    </div>
  );
};

export default FAQAccordionList;
